/*
Copyright 2025 TekNix Corporation

This software is proprietary and confidential to TekNix Corporation.
All rights reserved. No part of this software may be reproduced, distributed,
or transmitted in any form or by any means, including photocopying, recording,
or other electronic or mechanical methods, without the prior written permission
of TekNix Corporation, except in the case of brief quotations embodied in
critical reviews and certain other noncommercial uses permitted by copyright law.

For permission requests, write to TekNix Corporation at the address below:
TekNix Corporation
Legal Department

UNAUTHORIZED REPRODUCTION OR DISTRIBUTION IS STRICTLY PROHIBITED.
*/

/* eslint-disable vars-on-top */
import * as xhubchat from './xhubchat';

export type BrowserXHubChat = typeof xhubchat;

declare global {
  var __js_sdk_entrypoint: boolean | undefined;
  var xhubchat: BrowserXHubChat;
}

if (globalThis.__js_sdk_entrypoint) {
  throw new Error('Multiple xhubchat-sdk entrypoints detected!');
}
globalThis.__js_sdk_entrypoint = true;

export { decodeUserIdHash, hashUserId, validateUserIdHash } from './store/helper/user-hash';
export * from './xhubchat';
globalThis.xhubchat = xhubchat;
